import css from 'styled-jsx/css';

const styles = css.global`#carros-eletricos-diferenca {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 26px;
}

#carros-eletricos-diferenca .ctn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
}

.carros-eletricos-diferenca-title {
  font-family: 'SantanderHeadline';
  font-size: 20px;
  font-weight: 400;
  line-height: 29px;
  letter-spacing: 0em;
  text-align: center;
  color: #222222;
  max-width: 250px;
  margin: 0;
  margin-top: 15px;
}

.carros-eletricos-diferenca-title b {
  /* color: #cc0000; */
  font-weight: 800!important;
}

.carros-eletricos-diferenca-cards-div {
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  gap: 25px;
}

.carros-eletricos-diferenca-card {
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: center;
}

.carros-eletricos-diferenca-card-title {
  color: #222;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: "SantanderHeadline";
  font-size: 20px;
  font-style: normal;
  font-weight: 900;
  line-height: 36px;
  margin-top: 16px;
}

.carros-eletricos-diferenca-card-itens-div {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 255px;
  height: 255px;
  border: 1px solid #767676;
  box-shadow: 0px 4px 4px 0px #00000040;
}

.carros-eletricos-diferenca-card-itens {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 30px;
  z-index: 1;
  list-style-type: disc;
  margin-left: 12px;
}

.carros-eletricos-diferenca-card-item {
  width: 100%;
  font-family: 'SantanderHeadline';
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: left;
  color: #222222;
}

.carros-eletricos-diferenca-card-item b {
  /* color: #cc0000; */
  font-weight: 800!important;
}

.carros-eletricos-diferenca-card-img {
  position: absolute;
  bottom: 0;
  right: 10px;
  width: 111px;
  height: 86px;
  object-fit: contain;
  z-index: 0;
}
.carros-eletricos-diferenca-card-img-icon {
  position: absolute;
}

.carros-eletricos-diferenca-card-img-icon.ic_eletric_damage{
  bottom: 39px;
  right: 30px;
  width: 35px;
}

.carros-eletricos-diferenca-card-img-icon.ic_gas_station{
  bottom: 41px;
  right: 32px;
  width: 31px;
}

@media (min-width: 992px) {
  .only-mobi {
    display: none;
  }
  #carros-eletricos-diferenca {
    display: flex;
    padding-bottom: 40px;
  }

  #carros-eletricos-diferenca .ctn {
    gap: 36px;
  }

  .carros-eletricos-diferenca-title {
    font-size: 34px;
    margin-top: 32px;
    line-height: 32px;
    text-align: center;
    max-width: 100%;
  }

  .carros-eletricos-diferenca-cards-div {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-around;
  }

  .carros-eletricos-diferenca-card {
    gap: 24px;
    max-width: 587px;
    width: 100%;
  }

  .carros-eletricos-diferenca-card-title {
    font-size: 24px;
    color: #000000;
    margin: 32px auto 0;
  }

  .carros-eletricos-diferenca-card-itens-div {
    max-width: 555px;
    width: 100%;
    height: 300px;
    align-items: flex-start;
    border: 1px solid #767676;
    box-shadow: 0px 4px 4px 0px #00000040;
  }

  .carros-eletricos-diferenca-card-itens {
    padding: 24px 24px;
    margin-left: 34px;
  }

  .carros-eletricos-diferenca-card-item {
    font-size: 18px;
    line-height: 30px;
  }

  .carros-eletricos-diferenca-card-img {
    bottom: 10px;
    right: 10px;
    width: 111px;
    height: 89px;
  }
  
  .carros-eletricos-diferenca-card-img-icon.ic_eletric_damage{
    bottom: 48px;
    right: 27px;
    width: 42px;    
  }
  
  .carros-eletricos-diferenca-card-img-icon.ic_gas_station{
    bottom: 50px;
    right: 31px;
    width: 35px;
  }
}

@media (min-width: 1200px) {
  /* .carros-eletricos-diferenca-card-itens {
    padding: 40px 23px;
  } */

  .carros-eletricos-diferenca-card-img {
    bottom: 10px;
    right: 10px;
    width: 189px;
    height: 130px;
  }
  .carros-eletricos-diferenca-card-img-icon.ic_eletric_damage{
    bottom: 69px;
    right: 46px;
    width: 56px;
  }
  
  .carros-eletricos-diferenca-card-img-icon.ic_gas_station{
    bottom: 69px;
    right: 49px;
    width: 50px;
  }
}
`;

export default styles;